// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../lex-web-ui/node_modules/css-loader/dist/cjs.js??clonedRuleSet-14.use[1]!../../lex-web-ui/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-14.use[2]!./custom-chatbot-style.css");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../lex-web-ui/node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("2a8a9fa0", content, false, {"sourceMap":false,"shadowMode":false});
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../lex-web-ui/node_modules/css-loader/dist/cjs.js??clonedRuleSet-14.use[1]!../../lex-web-ui/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-14.use[2]!./custom-chatbot-style.css", function() {
     var newContent = require("!!../../lex-web-ui/node_modules/css-loader/dist/cjs.js??clonedRuleSet-14.use[1]!../../lex-web-ui/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-14.use[2]!./custom-chatbot-style.css");
     if(newContent.__esModule) newContent = newContent.default;
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}